let store = null;

export const setStore = newStore => {
	store = newStore;
};

const getStore = () => store;

export default getStore;
